import PasswordInput, { PasswordInputDataStructure } from './PasswordInput';

export { PasswordInputDataStructure };
export default PasswordInput;
